import { useState } from "react";
import { MessageSquareText } from "lucide-react";
import { fmtDateTime as fmtDate, useApiData } from "@/lib/api";
import { PageTitle } from "@/components/shell/DashboardShell";
import { MiniMarkdown } from "@/components/advisor/MiniMarkdown";

const Transcript = ({ id }) => {
  const { data, loading } = useApiData(`/admin/advisor/sessions/${id}`);
  if (loading || !data) return <p className="p-6 text-sm text-slate-500">Loading chat…</p>;
  return (
    <div className="space-y-3 p-5" data-testid="admin-advisor-transcript">
      <p className="text-xs text-slate-500">Started {fmtDate(data.created_at)}{data.page ? ` on ${data.page}` : ""}</p>
      {data.messages.map((m, i) => (
        <div key={i} className={`rounded-xl px-4 py-3 text-sm ${m.role === "user" ? "bg-[#123634] text-white" : "bg-[#F4F6F2] text-slate-800"}`} data-testid={`admin-advisor-message-${i}`}>
          <p className="mb-1 text-[10px] uppercase tracking-wider opacity-70">{m.role === "user" ? "Visitor" : "Advisor"} · {fmtDate(m.created_at)}</p>
          {m.role === "user" ? m.content : <MiniMarkdown text={m.content} />}
        </div>
      ))}
    </div>
  );
};

export default function AdminAdvisor() {
  const { data, loading } = useApiData("/admin/advisor/sessions");
  const [sel, setSel] = useState(null);
  const list = data || [];
  return (
    <div data-testid="admin-advisor-page">
      <PageTitle title="Advisor chats" text="Conversations visitors had with the AI product advisor. Use them to spot leads and common questions." />
      <div className="grid gap-5 lg:grid-cols-5">
        <div className="card-base max-h-[70vh] overflow-y-auto lg:col-span-2" data-testid="admin-advisor-list">
          {loading && <p className="p-5 text-sm text-slate-500">Loading…</p>}
          {!loading && !list.length && <p className="p-5 text-sm text-slate-500" data-testid="admin-advisor-empty">No chats yet.</p>}
          {list.map((s) => (
            <button key={s.id} type="button" onClick={() => setSel(s.id)} className={`block w-full border-b border-slate-100 px-5 py-4 text-left transition-colors hover:bg-slate-50 ${sel === s.id ? "bg-[#FBEDEA]/60" : ""}`} data-testid={`admin-advisor-session-${s.id}`}>
              <p className="line-clamp-2 text-sm font-medium text-slate-900">{s.preview}</p>
              <p className="mt-1 text-xs text-slate-500">{fmtDate(s.updated_at)} · {s.message_count} messages</p>
            </button>
          ))}
        </div>
        <div className="card-base min-h-[300px] lg:col-span-3">
          {sel ? <Transcript key={sel} id={sel} /> : <div className="flex h-full min-h-[300px] flex-col items-center justify-center gap-2 text-sm text-slate-500"><MessageSquareText className="h-6 w-6" /> Select a chat to read it</div>}
        </div>
      </div>
    </div>
  );
}
